module.exports = __webpack_public_path__ + "img/t-b-l.60ad0f6c.png";